export default __webpack_public_path__ + "static/media/P2PAY.d22cf01b.png";